<app-central-loader text="Entrando..."></app-central-loader>

<app-select-agente #selecionarAgente></app-select-agente>

<app-modal-message #modalMessage title="Não foi possível prosseguir" [hideClose]="true"></app-modal-message>